import _ from 'underscore';

export function roundPrice(price, pad = false) {
  if (pad) {
    return price && price.replace(/\.0+$/, '.00');
  }
  return price && price.replace(/\.00/, '');
}

export function addonsWithPrices(addons, pricingAddons) {
  if (addons.length !== pricingAddons.length) {
    pricingAddons.forEach((pricingAddon) => {
      if (pricingAddon.count <= 0) return;
      if (
        !addons.find(
          (addon) => parseInt(addon.id) === parseInt(pricingAddon.id)
        )
      ) {
        addons.push(pricingAddon);
      }
    });
  }

  return addons.map((addon) => {
    const pricing = _.find(pricingAddons, (pricingAddon) => {
      return parseInt(pricingAddon.id) === parseInt(addon.id);
    });
    return _.extend(addon, pricing || {});
  });
}

export function countAdultsIn(units, unitTypes) {
  let numOfAdults = 0;
  const adults = unitTypes.filter((u) => {
    return u.noun_plural.toLowerCase() === 'adults';
  });
  if (adults && adults.length > 0) {
    for (let i = 0; i < units.length; i++) {
      if (parseInt(units[i].id) === parseInt(adults[0].id)) {
        numOfAdults = units[i].count;
        break;
      }
    }
  }
  return numOfAdults;
}
